import React, { useState } from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import RailConfigPreview from "./RailConfigPreview";

const RailConfigList = (props) => {

    const [preview, setPreview] = useState(false);
    const [previewListRowData, setRreviewListRowData] = useState({});

    const railListPreviewHandler = (row) => {
        setRreviewListRowData(row);
        setPreview(true);
    }


    return (
        <div className="hotel-list">
            <div className="cdsn-detail-homepage-preview">
            <p><b>STB Homepage Preview</b></p>
            <button type="button"
            className="un-published"
            onClick={() => railListPreviewHandler(props?.fetchCDSNRailConfigList)}
          >
            Preview
          </button>
           {preview && <BasicModal
                popupOpen={preview}
                bodyMessage={<RailConfigPreview fetchCDSNHotelConfigList={props?.fetchCDSNHotelConfigList} welcomeMsgConfigList = {props?.welcomeMsgConfigList} setPreview={setPreview} previewListRowData={previewListRowData} />}
                popupSize={'col-11 cdsn-details-rail-preview p-0'}
                bodyElementMargin={'mb-0'}
            />}
        </div>
        </div>
    )
}

export default RailConfigList;